import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import { deletePushNotification } from '../../../actions';

class DeleteNotificationModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: this.props.modalData.show
        }
    }

    toggle = (refresh) => {
        this.setState({
            ...this.state,
            show: !this.state.show
        }, () => {
            setTimeout(() => {
                this.props.toggleModal(refresh);
            }, 500);
        });
    };

    handleDelete = () => {
        this.props.deletePushNotification(this.props.modalData.notificationId, () => {
            this.toggle(true);
        })
    };

    render() {
        return (
            <Modal isOpen={this.state.show} toggle={() => this.toggle(false)}>
                <ModalHeader toggle={() => this.toggle(false)}
                    className="modalHeader">{i18n.t('screens:appNotificationScreen.deleteModal.header')}</ModalHeader>
                <ModalBody>
                    {i18n.t('screens:appNotificationScreen.deleteModal.body')}
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        disabled={this.state.disableSubmit}
                        onClick={this.handleDelete}
                    >
                        <MaterialIcon icon="check" color="#fff"
                            size={20} />&nbsp;{i18n.t('common:buttons.confirm')}</Button>{' '}
                    <Button color="outline-primary" onClick={() => this.toggle(false)}>{i18n.t('common:buttons.cancel')}</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default connect(null, { deletePushNotification })(DeleteNotificationModal);


// WEBPACK FOOTER //
// ./src/components/brands/AppNotificationScreen/DeleteNotificationModal.js